import { JSX } from 'react';
import { DateField, Edit, SimpleForm } from 'react-admin';
import { LlmModelPriceFields } from './components/LlmModelPriceFields';
import { ChatFieldBridge } from '../chat-bot/components/ChatFieldBridge';

export const LlmModelPriceEdit: () => JSX.Element = (): JSX.Element => {
    return (
        <Edit>
            <SimpleForm>
                <LlmModelPriceFields />
                <div>
                    <span style={ { marginRight: '15px' } }>{ "Created At:" }</span>
                    <DateField source="createdAt" />
                </div>
                <div>
                    <span style={ { marginRight: '15px' } }>{ "Updated At:" }</span>
                    <DateField source="updatedAt" />
                </div>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
